import "./DiscountModal.css";
import images from "../../../../utilities/images/images";

const DiscountModal = ({
  title,
  description,
  couponCode,
  discountPercent,
  couponNote,
  history,
  packageId,
  onClose,
}) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(couponCode);
    alert("Coupon code copied and saved!");
  };
  const handleUpgradeClick = async () => {
    if (packageId) {
      history.push({
        pathname: `/package/${packageId}`,
        state: couponCode,
      });
    }
  };
  return (
    <div className="discount-modal-overlay">
      <div className="discount-modal">
        <button className="discount-close-btn" onClick={() => onClose()}>
          ×
        </button>
        <img
          src={images.percentageIcon}
          alt="Discount"
          className="discount-icon"
        />

        <h2 className="congrats-heading">
          <span className="highlight">{title}</span>
        </h2>
        <p className="subtext">{description}</p>

        <div className="discount-text">
          <p className="small">You have unlocked</p>
          <h1>
            {discountPercent}%<span>DISCOUNT</span>
          </h1>
        </div>

        <div className="coupon-box">
          <input type="text" value={couponCode} readOnly />
          <button onClick={handleCopy} className="copy-btn">
            <img src={images.copy} alt="Copy" />
          </button>
        </div>
        <p className="note">
          {" "}
          <img src={images.informIcon} alt="Details Information" />
          {couponNote}
        </p>

        <button className="upgrade-btn" onClick={handleUpgradeClick}>
          Upgrade Now
        </button>
      </div>
    </div>
  );
};

export default DiscountModal;
